import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import DesignerListItem from 'apps/find-designers/components/Listing/DesignerListItem';
import BlankSlate from 'components/BlankSlate';
import initTypeform from 'utils/initTypeform';
import { Creators } from 'apps/find-designers/propTypes';
import { InviteContextProvider } from './InviteContext';

class DesignerList extends Component {
    componentDidUpdate() {
        if (this.props.designers.length) return null;
        return initTypeform();
    }

    blankSlateMessage() {
        return (
            <span>
                <FormattedMessage id="blank_slate_message" />
            </span>
        );
    }

    blankSlate() {
        if (this.props.designers.length) return null;

        return (
            <BlankSlate
                title={<FormattedMessage id="no_designers_found" />}
                message={this.blankSlateMessage()}
                variations={['wide', 'padded-top']}
            />
        );
    }

    render() {
        return (
            <div>
                <InviteContextProvider>
                    {this.blankSlate()}
                    {this.props.designers.map(designer => {
                        return (
                            <DesignerListItem
                                key={designer.userId}
                                designer={designer}
                                designs={designer.designs}
                                expertiseCategories={designer.expertiseCategories}
                            />
                        );
                    })}
                </InviteContextProvider>
            </div>
        );
    }
}

DesignerList.defaultProps = {
    designers: [],
};

DesignerList.propTypes = {
    designers: Creators.isRequired,
};

export default DesignerList;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/DesignerList.jsx